{{ name | translate }}
<ng-container *ngIf="enableSort"
              [ngSwitch]="sortOrder">
  <mat-icon *ngSwitchCase="'asc'">keyboard_arrow_up</mat-icon>
  <mat-icon *ngSwitchCase="'desc'">keyboard_arrow_down</mat-icon>
</ng-container>
